import React from 'react';


import './Homepage.css'

import AboutUs from '../About-us/AboutUs';

import HeroSection from '../Herosection/HeroSection';
import NavbarHeader from '../Navbarheader/NavbarHeader';


import { useNavigate } from 'react-router-dom';
import Projects from '../Projects/Projects';
import Experience from '../Experience/Experience';
import Testimonial from '../Testimonial/Testimonial';
import Footer from '../Footer/Footer';


function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="scroll-container">
      <NavbarHeader navigate={navigate} />

      <HeroSection />
      <div style={{backgroundColor:"#1C1B1B"}}>
      <AboutUs />
      {/* <MySkills show={true} /> */}
      <Projects />
      <Experience />
      <Testimonial />
      </div>
      <Footer />
    </div>

  );
}

export default HomePage;
